module.exports = __webpack_public_path__ + "media/images/cali-unemployment-rate-graph-8178d455d30218417b8c3584f30fb274.png";